import { render } from "./LoadList.vue?vue&type=template&id=10f1dede&scoped=true"
import script from "./LoadList.vue?vue&type=script&lang=js"
export * from "./LoadList.vue?vue&type=script&lang=js"

import "./LoadList.vue?vue&type=style&index=0&id=10f1dede&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f1dede"]])

export default __exports__